import { ZONES, type ZoneDefinition, type ZoneId } from '../domain/content.js';
import type { GameState, ViewZoneProgress } from '../contract.js';
import { isGooTile } from './goo.js';
import { getTileAmount, isPermanentWall } from './tiles.js';

export function zoneAtTile(x: number, y: number): ZoneDefinition | null {
  return ZONES.find((zone) => x >= zone.minX && x < zone.minX + zone.width && y >= zone.minY && y < zone.minY + zone.height) ?? null;
}

export function zoneProgress(state: GameState, zone: ZoneDefinition | null): ViewZoneProgress {
  if (zone === null) {
    return {
      id: null,
      name: 'Uncharted Waste',
      percentCleared: 0,
      clearedTrashTiles: 0,
      totalTrashTiles: 0,
      techAwarded: false,
    };
  }

  let totalTrashTiles = 0;
  let clearedTrashTiles = 0;
  for (let y = zone.minY; y < zone.minY + zone.height; y++) {
    for (let x = zone.minX; x < zone.minX + zone.width; x++) {
      if (isPermanentWall(x, y)) continue;
      totalTrashTiles += 1;
      if (getTileAmount(state, x, y) <= 0 && !isGooTile(state, x, y)) clearedTrashTiles += 1;
    }
  }

  return {
    id: zone.id,
    name: zone.name,
    percentCleared: totalTrashTiles <= 0 ? 1 : clearedTrashTiles / totalTrashTiles,
    clearedTrashTiles,
    totalTrashTiles,
    techAwarded: state.zones.awardedTech[zone.id] === true,
  };
}

export function maybeAwardZoneTech(state: GameState): void {
  for (const zone of ZONES) {
    if (state.zones.awardedTech[zone.id] === true) continue;
    const progress = zoneProgress(state, zone);
    if (progress.totalTrashTiles <= 0 || progress.clearedTrashTiles < progress.totalTrashTiles) continue;
    state.zones.awardedTech[zone.id] = true;
    state.tech.points += 1;
    state.stats.techPointsEarned += 1;
    state.ui.statusMessage = `${zone.name} cleared. Tech point earned.`;
  }
}

export function zoneColor(zoneId: ZoneId | null): number {
  if (zoneId === null) return 0x33473a;
  return ZONES.find((zone) => zone.id === zoneId)?.color ?? 0x33473a;
}
